<template>
    <div>
        <ValidationObserver ref="formModalValidate" readonly="readonly">
            <b-row>
                <b-col cols="12">
                            <ValidationProvider name="payment_method" rules="required" v-slot="{valid, errors}">
                                <b-form-group :label="$t('payment_method')">
                                    <multi-selectbox :allow-empty="false"
                                                     :multiple="false"
                                                     :disabled="isReadOnly"
                                                     :validate-error="errors[0]" :options="options"
                                                     v-model="paymentMethod"></multi-selectbox>
                                </b-form-group>
                            </ValidationProvider>
                </b-col>
                <b-col cols="12" v-if="['wire'].includes(paymentMethod)">
                    <b-row>
                        <b-col md="4">
                            <ValidationProvider name="bank_name" :rules="['wire'].includes(paymentMethod)?'required':''" v-slot="{valid, errors}">
                                <b-form-group :label="$t('bank_name')">
                                    <b-form-input type="text"
                                                  v-model="request_data.bank_name"
                                                  :disabled="isReadOnly"
                                                  v-uppercase
                                                  :state="errors[0] ? false : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="4">
                            <ValidationProvider name="account_name" :rules="['wire'].includes(paymentMethod)?'required':''" v-slot="{valid, errors}">
                                <b-form-group :label="$t('account_holder')">
                                    <b-form-input type="text"
                                                  v-model="request_data.account_name"
                                                  :disabled="isReadOnly"
                                                  :state="errors[0] ? false : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="4">
                            <ValidationProvider name="bank_branch_address" :rules="['wire'].includes(paymentMethod)?'required':''" v-slot="{valid, errors}">
                                <b-form-group :label="$t('bank_branch_address')">
                                    <b-form-input type="text"
                                                  v-model="request_data.bank_branch_address"
                                                  :disabled="isReadOnly"
                                                  :state="errors[0] ? false : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="4">
                            <ValidationProvider name="account_number" :rules="['wire'].includes(paymentMethod)?'required':''" v-slot="{valid, errors}">
                                <b-form-group :label="$t('account_code')">
                                    <b-form-input type="text"
                                                  v-model="request_data.account_number"
                                                  :disabled="isReadOnly"
                                                  :state="errors[0] ? false : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="4">
                            <ValidationProvider name="iban" v-slot="{valid, errors}">
                                <b-form-group :label="$t('iban')">
                                    <b-form-input type="text"
                                                  v-model="request_data.iban"
                                                  :disabled="isReadOnly"
                                                  v-mask="['AA##-####-####-####-####-####-##']"
                                                  :state="errors[0] ? false : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="4">
                            <ValidationProvider name="intermediary_bank_name" v-slot="{valid, errors}">
                                <b-form-group :label="$t('intermediary_bank_name')">
                                    <b-form-input type="text"
                                                  v-model="request_data.intermediary_bank_name"
                                                  :disabled="isReadOnly"
                                                  :state="errors[0] ? false : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="4">
                            <ValidationProvider name="swift_code" :rules="['wire'].includes(paymentMethod)?'required':''" v-slot="{valid, errors}">
                                <b-form-group :label="$t('swift_code')">
                                    <b-form-input type="text"
                                                  v-model="request_data.swift_code"
                                                  :disabled="isReadOnly"
                                                  :state="errors[0] ? false : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="4">
                            <ValidationProvider name="aba_number" :rules="['wire'].includes(paymentMethod)?'required':''" v-slot="{valid, errors}">
                                <b-form-group :label="$t('aba_number')">
                                    <b-form-input type="text"
                                                  v-model="request_data.aba_number"
                                                  :disabled="isReadOnly"
                                                  :state="errors[0] ? false : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="4">
                            <ValidationProvider name="account_holder_address" :rules="['wire'].includes(paymentMethod)?'required':''" v-slot="{valid, errors}">
                                <b-form-group :label="$t('account_holder_address')">
                                    <b-form-input type="text"
                                                  v-model="request_data.account_holder_address"
                                                  :disabled="isReadOnly"
                                                  :state="errors[0] ? false : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>

                    </b-row>

                </b-col>
                <b-col cols="12" v-if="['credit_debit_card'].includes(paymentMethod)">
                    <b-row>
                        <b-col md="6">
                            <ValidationProvider name="card_holder_name" :rules="['credit_debit_card'].includes(paymentMethod)?'required':''" v-slot="{valid, errors}">
                                <b-form-group :label="$t('card_holder_name')">
                                    <b-form-input
                                        v-model="request_data.card_holder_name"
                                        :disabled="isReadOnly"
                                    ></b-form-input>
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="6">
                            <ValidationProvider name="card_number" :rules="['credit_debit_card'].includes(paymentMethod)?'required':''" v-slot="{valid, errors}">
                                <b-form-group :label="$t('credit_card_number')">
                                    <b-form-input
                                        v-model="request_data.card_number"
                                        :disabled="isReadOnly"
                                        v-mask="'####-####-####-####'"
                                        autocomplete="false"
                                    ></b-form-input>
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="3">
                            <ValidationProvider name="expiry_year" :rules="['credit_debit_card'].includes(paymentMethod)?'required':''" v-slot="{ errors }">
                                <b-form-group :label="$t('card_expiry_year')">
                                    <b-form-select v-model="request_data.expiry_year" :options="years"
                                                   :disabled="isReadOnly"
                                                   :state="errors[0] ? false : null"></b-form-select>
                                    <b-form-invalid-feedback v-if="errors[0]"
                                                             v-html="errors[0]"></b-form-invalid-feedback>
                                </b-form-group>

                            </ValidationProvider>
                        </b-col>
                        <b-col md="3">
                            <ValidationProvider name="expiry_month" :rules="['credit_debit_card'].includes(paymentMethod)?'required':''" v-slot="{ errors }">
                                <b-form-group :label="$t('card_expiry_month')">
                                    <b-form-select v-model="request_data.expiry_month" :state="errors[0] ? false : null"
                                                   :disabled="isReadOnly"
                                                   :options="['01', '02', '03', '04', '05', '06', '07', '08', '09', 10, 11, 12]"></b-form-select>
                                    <b-form-invalid-feedback v-if="errors[0]"
                                                             v-html="errors[0]"></b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="6">
                            <ValidationProvider name="security_code" :rules="['credit_debit_card'].includes(paymentMethod)?'required':''" v-slot="{valid, errors}">
                                <b-form-group :label="$t('security_code')">
                                    <b-form-input
                                        v-model="request_data.security_code"
                                        :disabled="isReadOnly"
                                        v-mask="'###'"
                                        autocomplete="false"
                                    ></b-form-input>
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>



                    </b-row>
                </b-col>
                <b-col v-if="paymentMethod!=null">
                    <b-row>
                        <b-col md="12">
                            <b-form-group label="Home Address (Street Name, Building Name/Number, Apartment/Unit Number)">
                                <ValidationProvider
                                    name="address"
                                    rules="required"
                                    v-slot="{ valid, errors }"
                                >
                                    <b-input-group class="mb-3" >
                                        <b-form-input
                                            v-model="request_data.address"
                                            :disabled="isReadOnly"
                                            :class="errors[0] ? 'is-invalid' : ''"
                                        >
                                        </b-form-input>
                                    </b-input-group>
                                    <b-form-invalid-feedback
                                        v-if="errors[0]"
                                        v-html="errors[0]"
                                        class="mb-2"
                                    ></b-form-invalid-feedback>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group :label="$t('city')">
                                <ValidationProvider
                                    name="city"
                                    rules="required"
                                    v-slot="{ valid, errors }"
                                >
                                    <b-input-group class="mb-3">
                                        <b-form-input
                                            v-model="request_data.city"
                                            :disabled="isReadOnly"
                                            :class="errors[0] ? 'is-invalid' : ''"
                                        >
                                        </b-form-input>
                                    </b-input-group>
                                    <b-form-invalid-feedback
                                        v-if="errors[0]"
                                        v-html="errors[0]"
                                        class="mb-2"
                                    ></b-form-invalid-feedback>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group :label="$t('state')">
                                <ValidationProvider name="state"
                                                    rules="required"
                                                    v-slot="{ valid, errors }">
                                    <b-input-group class="mb-3" >
                                        <b-form-input
                                            v-model="request_data.state"
                                            :disabled="isReadOnly"
                                            :class="errors[0] ? 'is-invalid' : ''"
                                        >
                                        </b-form-input>
                                    </b-input-group>
                                    <b-form-invalid-feedback
                                        v-if="errors[0]"
                                        v-html="errors[0]"
                                        class="mb-2"
                                    ></b-form-invalid-feedback>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group :label="$t('country')">
                                <ValidationProvider
                                    name="country"
                                    rules="required"
                                    v-slot="{ valid, errors }"
                                >
                                    <country-selectbox
                                        v-model="request_data.country"
                                        :disabled="isReadOnly"
                                        :public="true"
                                        :validateError="errors[0]"
                                        valueType="code"
                                    ></country-selectbox>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                        <b-col  md="6">
                            <ValidationProvider
                                name="zip_code"
                                rules="required"
                                v-slot="{ valid, errors }"
                            >
                                <b-form-group :label="$t('zip_code')">
                                    <b-form-input
                                        v-model="request_data.zip_code"
                                        :disabled="isReadOnly"
                                        :state="errors[0] ? false : valid ? true : null"
                                    />
                                    <b-form-invalid-feedback v-if="errors[0]">
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6" v-if="!isReadOnly">
                            <SignatureComponent
                                v-model="request_data.signature"
                                ref="signatureComponentRef"
                            />
                        </b-col>
                    </b-row>
                </b-col>

                <b-col cols="12" class="d-flex justify-content-center align-items-center" v-if="!isReadOnly">
                    <b-form-group class="mb-0">
                        <b-button variant="primary" block @click="save" :disabled="formLoading">
                            {{ $t('save').toUpperCase() }}
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>
</template>

<script>
import StudentRequestService from '@/services/StudentRequestService';
import {EventBus} from "@/main";
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox.vue";
import SignatureComponent from "@/components/elements/Signature.vue";

export default {
    components: {SignatureComponent, MultiSelectbox},
    props: {
        data: {
            type: Object,
            required: true,
        },
        isReadOnly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            formProgress:null,
            paymentMethod:null,
            options:[
                {
                    text:'Wire',
                    value:"wire"
                },
                {
                    text:'Credit/Debit Card',
                    value:"credit_debit_card"
                },
            ],
            request_data: {},
            formLoading: false,
        };
    },
    created() {
        this.request_data = this.data.request_data || {};
        if(this.request_data.expiration_date){
            const [month, year] = this.request_data.expiration_date.split('/');
            this.request_data.expiry_month = month;
            this.request_data.expiry_year = year;
        }
        this.paymentMethod = this.data.request_data?.payment_method || null;
    },
    watch:{
      'paymentMethod'(newVal, oldVal) {
          if (newVal!=oldVal){
              this.request_data=this.data.request_data || {};
          }

      }
    },
    computed: {
        getReservationToken() {
            return this.$store.getters['roomReservationSystem/getReservationToken'];
        },
        years() {
            let year = new Date().getFullYear()
            let index = 0
            const nums = []

            while (index < 11) {
                nums.push(year + index)
                index++
            }

            return nums
        },
    },
    methods: {
        formClear(){
          this.formProgress=null;
        },
        async save() {
            this.formLoading = true;
            const isFormValid = await this.$refs.formModalValidate.validate()
            const isSignatureValid = this.$refs.signatureComponentRef.validate();
            if (isFormValid && isSignatureValid) {
                const config = {
                    headers: { 'Content-Type': 'multipart/form-data' },
                };
                const formData = new FormData();
                formData.append('request_type', 'security_deposit_refund_request');
                formData.append('housing_reservation_id', this.data.id);
                if (this.paymentMethod === 'credit_debit_card') {
                    this.request_data.expiration_date = this.request_data.expiry_month + '/' + this.request_data.expiry_year;
                }
                this.request_data.payment_method = this.paymentMethod;
                Object.entries(this.request_data).forEach(([key, value]) => {
                    formData.append(`request_data[${key}]`, value);
                });
                try {
                    const response = await StudentRequestService.studentRequest(formData, config);
                    this.$toast.success(this.$t('api.' + response.data.message));
                    this.$router.push('/housing/request/list');
                } catch (error) {
                    EventBus.$emit('formClearRequest');
                    this.showErrors(error, this.$refs.formModalValidate);
                } finally {
                    this.formLoading = false;
                }

            } else {
                this.formLoading = false;


            }
        },

    },
};
</script>
